<template>
  <div>
    <ThePageTitleVue>
      <h3>{{ $t('about_2') }}</h3>
      <p>{{ $t('about_3') }}</p>
    </ThePageTitleVue>
    <div class="part1 content">
      <h3 class="main-title" style="text-align:center">{{ $t('about_4') }}</h3>
      <p class="sub-title">{{ $t('about_5') }}</p>
      <div class="com-w">
        <div class="com-i" style="border-right: 1px solid #D7DDE1;margin-right: 60px">
            <div class="com-i-l">
              <img src="../assets/images/com_1.png" alt="">
            </div>
            <div class="com-i-r">
              <img src="../assets/images/com_2.png" style="width: 166px;" alt="">
              <p>4.4/5  Excellent</p>
            </div>
        </div>
        <div class="com-i">
            <div class="com-i-l">
              <img src="../assets/images/com_3.png" alt="">
            </div>
            <div class="com-i-r">
              <p>{{ $t('about_6') }}</p>
            </div>
        </div>
      </div>
    </div>
    <div class="content about-wrap">
      <h4 class="title">{{ $t('about_7') }}</h4>
      <p class="desc">{{ $t('about_8') }}</p>
      <div class="pic-wrap">
        <div class="pic-item">
          <img class="ad-bg" src="../assets/images/about/ad_uk.png" alt="">
          <h5>
            <img src="../assets/images/about/ad_icon.png" alt="">
            {{ $t('about_9') }}
          </h5>
          <p>{{ $t('about_10') }}</p>
        </div>

        <div class="pic-item">
          <img class="ad-bg" src="../assets/images/about/ad_au.png" alt="">
          <h5>
            <img src="../assets/images/about/ad_icon.png" alt="">
            {{ $t('about_13') }}
          </h5>
          <p>{{ $t('about_14') }}</p>
        </div>

        <div class="pic-item">
          <img class="ad-bg" src="../assets/images/about/ad_sa.png" alt="">
          <h5>
            <img src="../assets/images/about/ad_icon.png" alt="">
            {{ $t('about_11') }}
          </h5>
          <p>{{ $t('about_12') }}</p>
        </div>
      </div>

      <h4 class="title">{{ $t('about_15') }}</h4>
      <p class="desc">{{ $t('about_16') }}</p>
      
    </div>
  </div>
</template>

<script>
import ThePageTitleVue from "./home/ThePageTitle.vue"
    export default {
      name: "about",
      computed: {
        aboutText() {
          return this.$t("about_2")
        }
      },
      components: {
        ThePageTitleVue,
      },
      methods:{
        googlePay(){
          window.open('https://play.google.com/store/apps/details?id=com.wetrade.app')
        },
        appleStore(){
          window.open('')
        },
        facebook(){
          window.open('https://www.facebook.com/WeTradeApp')
        },
        contact(){
          // window.open('support@wetrade.one')
          window.location.href = 'mailto:support@wetrade.one'
        }
      }
    }
</script>

<style scoped lang="scss">
.part1{
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #D7DDE1;
  padding: 30px 140px;
  margin-top: 80px;
  .com-w{
    display: flex;
    margin-top: 40px;
    .com-i{
      flex: 1;
      display: flex;
      align-items: center;
      .com-i-l{
        margin-right: 60px;
        img{
          width: 132px;
          height: 80px;
        }
      }
      .com-i-r{
        p{
          font-size: 16px;
          font-weight: 400;
          color: #000000;
          line-height: 24px;
        }
      }
    }
  }
}
.main-title{
  height: 40px;
  font-size: 32px;
  font-weight: bold;
  color: #181D24;
  line-height: 40px;
}
.sub-title{
  font-size: 16px;
  font-weight: 400;
  color: #5C6E7B;
  line-height: 24px;
  margin-top: 20px;
  width: 800px;
  text-align: center;
}
.about-wrap{
  margin-bottom: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title{
    height: 40px;
    font-size: 32px;
    font-weight: bold;
    color: #181D24;
    line-height: 40px;
    margin-top: 80px;
  }
  .desc{
    font-size: 16px;
    font-weight: 400;
    color: #5C6E7B;
    line-height: 24px;
    margin-top: 20px;
    width: 800px;
    text-align: center;
  }
  .pic-wrap{
    display: flex;
    margin-top: 30px;
    .pic-item{
      width: 340px;
      height: 100%;
      margin-right: 80px;
      background: #FFFFFF;
      border-radius: 12px;
      border: 1px solid #D7DDE1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 10px 20px;
      .ad-bg{
        width: 320px;
        height: 140px;
      }
      h5{
        color: #181D24;
        line-height: 24px;
        font-size: 16px;
        width: 320px;
        display: flex;
        align-items: center;
        margin-top: 18px;
        padding: 0 20px;
        img{
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
      }
      p{
        width: 320px;
        padding: 0 20px;
        color: #5C6E7B;
        line-height: 20px;
        font-size: 14px;
        margin-top: 6px;
      }
    }
    .pic-item:nth-child(3){
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue